import { render, staticRenderFns } from "./newCustomersRegionPage.vue?vue&type=template&id=fc55578e&scoped=true&"
import script from "./newCustomersRegionPage.vue?vue&type=script&lang=js&"
export * from "./newCustomersRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./newCustomersRegionPage.vue?vue&type=style&index=0&id=fc55578e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc55578e",
  null
  
)

export default component.exports